import './VKbd.sass'

import { createSimpleFunctional } from '@/util'

export const VKbd = createSimpleFunctional('v-kbd')
